var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "plot-page" },
    [
      _c("plot-list", {
        attrs: {
          novelId: _vm.novelId,
          plotId: _vm.effectivePlotId,
          subPlots: _vm.subPlots,
        },
      }),
      _vm.plot
        ? _c("plots", {
            staticClass: "plot",
            attrs: {
              "novel-id": _vm.novelId,
              plotId: _vm.effectivePlotId,
              plot: _vm.plot,
            },
            on: {
              showHistoryDialog: function ($event) {
                _vm.isHistoryManageDialogOpen = true
              },
            },
          })
        : _vm._e(),
      _vm.plot
        ? _c("history-manage-dialog", {
            attrs: {
              "is-open": _vm.isHistoryManageDialogOpen,
              "data-type": "pl",
              title: _vm.historyDialogTitle,
              "novel-id": _vm.novelId,
              "data-id": _vm.plotDataId,
            },
            on: {
              close: function ($event) {
                _vm.isHistoryManageDialogOpen = false
              },
              restore: _vm.onPlotRestore,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function ({ historyItem }) {
                    return [
                      historyItem
                        ? _c(
                            "div",
                            [
                              _c("plots", {
                                attrs: {
                                  "novel-id": _vm.novelId,
                                  "plot-id": historyItem.item.plotId,
                                  plot: historyItem.item,
                                  "is-viewed-by-external-user": true,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              422949877
            ),
          })
        : _vm._e(),
      _vm.isEnableMobile && !_vm.isHamburgerMenuOpen
        ? _c("slide-shared-link-menu", {
            staticClass: "slide-menu",
            attrs: { novelId: _vm.novelId, kind: "plot" },
          })
        : _vm._e(),
      _vm.isShowPublishSharedLink
        ? _c(
            "div",
            { staticClass: "dialog" },
            [
              _c("publish-shared-link", {
                staticClass: "dialog-content",
                attrs: { novelId: _vm.novelId, kind: "plot" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }